import * as React from "react"
import styled from "styled-components"
import { HorizontalSpacer } from "../atoms/spacers"
import { MediaQuery } from "../../utils/design-helpers"
import Body from "../atoms/typography/Body"

interface MetricChipProps {
  icon: React.ReactNode
  value: string
}

const MetricContainer = styled.div`
  border: ${(props) => `${props.theme.borders.smallWidth} solid ${props.theme.colors.greyDark}`};
  padding: ${(props) => props.theme.spacings.large};
  box-shadow: 0px 0px 4px rgba(119, 119, 119, 0.25);
  border-radius: ${(props) => props.theme.borders.softRadius};

  ${MediaQuery.XS} {
    margin: 0.5rem;
  }
`

const MetricChip: React.FunctionComponent<MetricChipProps> = ({ icon, value }) => {
  return (
    <MetricContainer>
      <div style={{ display: "flex", justifyContent: "center" }}>{icon}</div>
      <HorizontalSpacer spacing={0.5} />
      <div style={{ display: "flex", justifyContent: "center" }}>
        <Body>{value}</Body>
      </div>
    </MetricContainer>
  )
}

export default MetricChip
